export default "assets/0c4c1367b130990c53d11b06ee8993d4.png";